<div class="product-dialog">

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <div mat-dialog-title>

  </div>
  <div mat-dialog-content>
    <div class="fx-row-wrap">
      <div class="fx-flex-100 gt-sm-fx-flex-50-in-wrap">
        <div class="swiper-container h-100">
          <div class="swiper-wrapper img-parent">
            <img [default]="'assets/images/product/no-img.png'"
              [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory/'+$safeNavigationMigration(product?.ImageUrl)" alt=""
              class="img-fluid">
          </div>
        </div>
      </div>
      <div class="fx-flex-100 gt-sm-fx-flex-50-in-wrap" [appBreakpointClass]="{'gt-sm':'px-2 m-0','sm':'mt-2','xs':'mt-2'}">
        <div class="product-right">
          <div class="product-details">
            <h2 class="mb-10">{{product?.ProductName}}</h2>
            <h4 class="mb-10"><del>{{$safeNavigationMigration(product?.OriginalPrice) |
            currency:companyService.selectedCurrency.CurrencyCode}}</del></h4>
            <h3 class="price mb-10"
              [textContent]="getPrice(product, OrderQuantityCount) | currency:companyService.selectedCurrency.CurrencyCode">
            </h3>
            <div class="discription">
              <p class="bold">Product details</p>
              <p class="text-muted productDescription" [innerHTML]="$safeNavigationMigration(product?.Description)"></p>
            </div>
          </div>
          @if (product?.HasOptions) {
            <div class="py-1 mt-15">
              @if (product?.ItemOptions && product?.ItemOptions.length>0) {
                <div>
                  @for (option of product?.ItemOptions; track option; let i = $index) {
                    <div class="m-0 p-20-0 custom-size">
                      <p [textContent]="option.Option"></p>
                      <mat-select readonly="true" [(ngModel)]="value[i]"
                        (selectionChange)="checkOptions($safeNavigationMigration(product?.ItemOptions));" name="value.Option"
                        placeholder="Select {{option.Option}}" (click)="openSelect($event)" class="md-no-underline-select">
                        @for (value of getValidValues(product, option, option.Values); track value) {
                          <mat-option
                            (ngInit)="setInitialItemOption(option, value)" [value]="value.Option"
                            (click)="value.isAvailable && selectOption(product, option, value, false)">
                          {{value.Option}} </mat-option>
                        }
                      </mat-select>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div class="fx-row fx-main-between fx-cross-center">
            <div class="quantity mt-15">
              <span class="text-muted fw-500">Quantity</span>
              <div class="text-muted mt-15 fx-row xs-fx-col">
                <div class="fx-row fx-main-center fx-cross-start">
                  <button [disabled]="(!isOptionsSelected && product?.ItemOptions.length>0)" mat-icon-button
                    matTooltip="Remove" (click)="decreaseQuantity()">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input [(ngModel)]="OrderQuantityCount" maxlength="2" validate
                    [disabled]="!isOptionsSelected && product?.ItemOptions.length>0" inputonlynumber="true"
                    name="quantity" (keyup)="($event.which === 38) ? increaseQuantity() : 0"
                    (keydown)="($event.which === 40) ? decreaseQuantity() : 0" class="form-control input-number">
                  <button [disabled]="(!isOptionsSelected && product?.ItemOptions.length>0)" mat-icon-button
                    matTooltip="Add" (click)="increaseQuantity()">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
            </div>

          </div>
          <div>
            <button [disabled]="product?.HasOptions && !isOptionsSelected && product?.ItemOptions.length>0"
              mat-raised-button color="primary" class="btn-project mr-10"
              (click)="buyButtonEnabled() && addToCart('', product)" translate="">{{'global_addtocart' |
            translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>